import styled, { css } from "styled-components";
import { FC } from "react";

export enum DividerTestIds {
  Component = "divider",
}

type DividerVariant = "light" | "bold";

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

type DividerElementProps = {
  $variant: DividerVariant;
};

const DividerElement = styled.div<DividerElementProps>`
  width: 100%;
  height: 1px;
  margin: 8px 16px;

  ${({ $variant }) => {
    switch ($variant) {
      case "light":
        return css`
          background-color: var(--color-primary-100);
        `;
      case "bold":
      default:
        return css`
          background-color: var(--color-primary-200);
        `;
    }
  }}
`;

type Props = {
  id?: string;
  className?: string;
  testId?: string;
  variant?: DividerVariant;
};

export const Divider: FC<Props> = ({
  id,
  className,
  testId,
  variant = "bold",
}) => (
  <Container
    id={id}
    className={className}
    data-testid={testId ?? DividerTestIds.Component}
  >
    <DividerElement $variant={variant} />
  </Container>
);
